import { useTranslation } from 'react-i18next';
import { partTestId } from '@connect-x-app/shared-utils';

import { Button } from '../../button';
import { Modal } from '../Modal';
import { ModalOpener } from '../ModalOpener';

type Props = {
  cancelButtonTheme?: 'neutral' | 'primary' | 'negative' | 'dark';
  cancelText?: string;
  confirmButtonTheme?: 'neutral' | 'primary' | 'negative' | 'dark';
  confirmText: string;
  content: string;
  isLoading?: boolean;
  onCancel?: () => void;
  onConfirm: () => void;
  preventBackdropDismiss?: boolean;
  swapButtons?: boolean;
  testId?: string;
  title?: string;
};

export const ConfirmationModal = ({
  cancelButtonTheme = 'negative',
  cancelText,
  confirmButtonTheme = 'primary',
  confirmText,
  content,
  isLoading,
  onCancel,
  onConfirm,
  preventBackdropDismiss = false,
  swapButtons = false,
  testId,
  title,
}: Props) => {
  const { t } = useTranslation();

  const onClickCancel = () => {
    if (!isLoading) {
      onCancel?.();
      ModalOpener?.instance.close();
    }
  };

  const cancelButton = (
    <Button
      disabled={isLoading}
      isOutline={!swapButtons}
      onClick={onClickCancel}
      testId={partTestId(testId, 'cancel')}
      theme={cancelButtonTheme}
    >
      {cancelText ?? t('SHARED.BUTTONS.CANCEL')}
    </Button>
  );

  const confirmButton = (
    <Button
      isOutline={swapButtons}
      loading={isLoading}
      onClick={() => {
        onConfirm?.();
        ModalOpener?.instance.close();
      }}
      testId={partTestId(testId, 'confirm')}
      theme={confirmButtonTheme}
    >
      {confirmText}
    </Button>
  );

  return (
    <Modal onCancel={onClickCancel} preventBackdropDismiss={preventBackdropDismiss}>
      <Modal.Header onCancel={onClickCancel}>{title}</Modal.Header>
      <Modal.Content>
        <p data-test={partTestId(testId, 'content')}>{content}</p>
      </Modal.Content>
      <Modal.Buttons>
        {swapButtons ? confirmButton : cancelButton}
        {swapButtons ? cancelButton : confirmButton}
      </Modal.Buttons>
    </Modal>
  );
};
